import * as api from 'dashboard/resources/eft-history.api';
import moment from 'moment';
import actionTypes from './action-types';

export const fetchEftHistoryRequest = () => ({
  type: actionTypes.FETCH_EFT_HISTORY_REQUEST,
  name: 'eftHistoryStatusLoadingStatus',
});

export const fetchEftHistorySuccess = (items, pagination) => ({
  type: actionTypes.FETCH_EFT_HISTORY_SUCCESS,
  name: 'eftHistoryStatusLoadingStatus',
  items,
  pagination,
});

export const fetchEftHistoryFailure = () => ({
  type: actionTypes.FETCH_EFT_HISTORY_FAILURE,
  name: 'eftHistoryStatusLoadingStatus',
});

export const fetchEftHistory = (params) => async (dispatch, getState) => {
  try {
    const { session } = getState();
    const { locale } = session;
    const retailerId = params.filters.retailerId || session.retailer.retailerId;
    const queryParams = {
      ...params,
      locale,
      filters: {
        startDate: moment(params.filters.startDate).format('YYYY-MM-DD'),
        endDate: moment(params.filters.endDate).format('YYYY-MM-DD'),
      },
    };

    dispatch(fetchEftHistoryRequest());
    const { content, ...pagination } = await api.fetchEftHistory(queryParams, retailerId);
    dispatch(fetchEftHistorySuccess(content, pagination));
  } catch (error) {
    console.error('FETCH_EFT_HISTORY', error);
    dispatch(fetchEftHistoryFailure());
  }
};

export const fetchEftExtensionsRequest = () => ({
  type: actionTypes.FETCH_EFT_EXTENSIONS_REQUEST,
});

export const fetchEftExtensionsSuccess = (extensions) => ({
  type: actionTypes.FETCH_EFT_EXTENSIONS_SUCCESS,
  extensions,
});

export const fetchEftExtensionsFailure = () => ({
  type: actionTypes.FETCH_EFT_EXTENSIONS_FAILURE,
});

export const fetchEftExtensions = () => async (dispatch) => {
  try {
    dispatch(fetchEftExtensionsRequest());
    const extensions = await api.fetchEftExtensions();
    dispatch(fetchEftExtensionsSuccess(extensions));
  } catch (error) {
    console.error('FETCH_EFT_EXTENSIONS', error);
    dispatch(fetchEftExtensionsFailure());
  }
};

export const fetchRetailerEFTDetailRequest = () => ({
  type: actionTypes.FETCH_RETAILER_EFT_DETAIL_DATE_REQUEST,
});

export const fetchRetailerEFTDetailSuccess = (date) => ({
  type: actionTypes.FETCH_RETAILER_EFT_DETAIL_DATE_SUCCESS,
  date,
});

export const fetchRetailerEFTDetailFailure = () => ({
  type: actionTypes.FETCH_RETAILER_EFT_DETAIL_DATE_FAILURE,
});

export const fetchRetailerEFTDetailDate = (id) => async (dispatch, getState) => {
  try {
    const { session } = getState();
    const retailerId = id || session.retailer.retailerId;

    dispatch(fetchRetailerEFTDetailRequest());
    const date = await api.fetchRetailerEFTDetailDate(retailerId);
    dispatch(fetchRetailerEFTDetailSuccess(date));
  } catch (error) {
    console.error('FETCH_RETAILER_EFT_DETAIL_DATE', error);
    dispatch(fetchRetailerEFTDetailFailure());
  }
};

export const downloadEftInvoiceRequest = () => ({
  type: actionTypes.DOWNLOAD_EFT_INVOICE_REQUEST,
});

export const downloadEftInvoiceSuccess = () => ({
  type: actionTypes.DOWNLOAD_EFT_INVOICE_SUCCESS,
});

export const downloadEftInvoiceFailure = () => ({
  type: actionTypes.DOWNLOAD_EFT_INVOICE_FAILURE,
});

export const downloadEftInvoice =
  (id = null, invoiceWeekEndDate, extension) =>
  (dispatch, getState) => {
    const { session } = getState();
    const retailerId = id || session.retailer.retailerId;

    try {
      dispatch(downloadEftInvoiceRequest());
      dispatch(downloadEftInvoiceSuccess());

      return api.downloadEftInvoice({ retailerId, invoiceWeekEndDate, extension });
    } catch (error) {
      console.error('DOWNLOAD_EFT_INVOICE', error);
      dispatch(downloadEftInvoiceFailure());
    }
  };



// WEBPACK FOOTER //
// ./src/modules/dashboard/actions/eft-history/eft-history.actions.js